var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatahubFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.81 9.778c-.932 0-1.729.575-2.059 1.389h-3.03a3.886 3.886 0 00-1.298-2.144l1.076-1.498a1.664 1.664 0 001.978-1.636 1.667 1.667 0 10-2.937 1.077l-1.058 1.472a3.874 3.874 0 00-2.848-.108L8.122 5.713a2.21 2.21 0 00.577-1.49 2.222 2.222 0 10-2.222 2.221c.047 0 .093-.004.14-.007l1.599 2.771a3.877 3.877 0 00-1.143 2.236H5.825a1.666 1.666 0 100 1.112h1.248a3.88 3.88 0 001.124 2.218l-1.61 2.787c-.037-.002-.073-.005-.11-.005a2.222 2.222 0 101.627.711l1.505-2.606a3.88 3.88 0 002.873-.099l1.058 1.472a1.667 1.667 0 10.96-.56l-1.077-1.497a3.886 3.886 0 001.297-2.144h3.031a2.222 2.222 0 102.06-3.055z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatahubFill);
export default __webpack_public_path__ + "33a447411666a1d8543c2025602e8e4f.svg";
export { ForwardRef as ReactComponent };